import { Collapsable } from "~/shared/ui/kit/components/Collapsable"
import { type ComponentProps, useEffect, useState } from "react"
import { inv } from "~/shared/lib/utils"
import { MaterialIcon } from "~/shared/ui/kit/components/MaterialIcon"
import { InfoPanel, type InfoPanelProps } from "~/shared/ui/components/panels/InfoPanel"

const CollapsableContent = ({ open, children }) => <Collapsable open={open}>
	<div>{children}</div>
</Collapsable>

/**
 * Комбинация компонентов [InfoPanel](/docs/shared-ui-component-infopanel--docs) и [Collapsable](/docs/shared-ui-kit-collapsable--docs).
 */
export const CollapsableInfoPanel = ({ open = false, header, itemClassName, itemContentClassName, itemLabelClassName, rootRef, itemsContainerProps, ...props }: {
	open?: boolean
} & InfoPanelProps<typeof Collapsable> & ComponentProps<"div">) => {

	const [locOpen, setLocOpen] = useState(open)

	useEffect(() => {
		setLocOpen(open)
	}, [open])

	return <InfoPanel
		rootRef={rootRef}
		contentStyle={{ padding: "0" }}
		itemClassName={itemClassName}
		itemContentClassName={itemContentClassName}
		itemLabelClassName={itemLabelClassName}
		itemsContainerElementType={CollapsableContent}
		itemsContainerProps={{ ...itemsContainerProps, open: locOpen }}
		header={<div onClick={() => setLocOpen(inv)}
					 className="flex items-center justify-between cursor-pointer">
			<div>{header}</div>
			<MaterialIcon name="expand_more" style={{
				transition: "transform 0.2s",
				transform: locOpen ? "rotate(180deg)" : "rotate(0deg)"
			}} />
		</div>} {...props} />
}